<xemex-dialog-shell [title]="'myProfile.editProfile.title' | translate">
  <div class="edit-profile-dialog__avatar-field">
    <span class="edit-profile-dialog__avatar-label">
      {{ 'myProfile.editProfile.pictureLabel' | translate }}
    </span>

    <div class="edit-profile-dialog__avatar-row">
      <xemex-avatar [src]="croppedImage" size="3rem" />

      <div class="edit-profile-dialog__avatar-actions">
        <xemex-text-button
          type="button"
          intent="primary"
          icon="photo_camera"
          (click)="onUploadAvatar()"
        >
          {{
            (hasAvatar
              ? 'myProfile.editProfile.btnChangePicture'
              : 'myProfile.editProfile.btnUploadPicture'
            ) | translate
          }}
        </xemex-text-button>

        @if (hasAvatar) {
          <xemex-text-button type="button" intent="destructive" (click)="onRemoveAvatar()">
            {{ 'myProfile.editProfile.btnRemovePicture' | translate }}
          </xemex-text-button>
        }
      </div>
    </div>

    <span class="edit-profile-dialog__avatar-hint">
      {{ 'myProfile.editProfile.pictureHint' | translate }}
    </span>
  </div>

  <div class="edit-profile-dialog__divider my-6"></div>

  <form class="edit-profile-dialog__form-grid" [formGroup]="profileForm">
    <xemex-text-field
      formControlName="firstName"
      [label]="'myProfile.tabs.info.content.firstName' | translate"
      [placeholder]="'general.placeholderInput' | translate"
    />

    <xemex-text-field
      formControlName="lastName"
      [label]="'myProfile.tabs.info.content.lastName' | translate"
      [placeholder]="'general.placeholderInput' | translate"
    />

    <xemex-text-field
      formControlName="email"
      [type]="'email'"
      [label]="'myProfile.tabs.info.content.email' | translate"
      [placeholder]="'general.placeholderInput' | translate"
      [invalid]="hasError('email', 'email')"
      [errorText]="'error.emailInvalid' | translate"
    />

    <xemex-text-field
      formControlName="phone"
      [label]="'myProfile.tabs.info.content.phone' | translate"
      [placeholder]="'general.placeholderInput' | translate"
    />

    <xemex-select-field [label]="'myProfile.tabs.info.content.language' | translate">
      <mat-select formControlName="language" [placeholder]="'general.placeholderInput' | translate">
        @for (language of LANGUAGES; track language.code) {
          <mat-option [value]="language.code.toUpperCase()">
            {{ language.translationCode | translate }}
          </mat-option>
        }
      </mat-select>
    </xemex-select-field>
  </form>

  <div actions class="edit-profile-dialog__actions">
    <xemex-text-button type="button" intent="primary" (click)="onCancel()">
      {{ 'general.btnCancel' | translate }}
    </xemex-text-button>
    <xemex-filled-button type="button" (click)="onSave()">
      {{ 'general.btnSaveChanges' | translate }}
    </xemex-filled-button>
  </div>
</xemex-dialog-shell>
